import * as TE from 'fp-ts/TaskEither';
import axios from 'axios';
import { RequestError } from './requestError';
import * as Err from '@fixtuur/error-context';
export const get = (url) => TE.tryCatch(() => axios.get(url), err => Err.construct(RequestError.FetchError, {
    originalError: JSON.stringify(err),
    requestUrl: url,
}));
